import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import AppScss from '../assets/styles/App.scss';
import {GETTERS as LOCATION_GETTERS, NAMESPACE as LOCATION_NAMESPACE} from "@/constants/vuex/location"
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const getLocales = () => {
  try {
    const store = require('@/store').default
    return store?.getters?.[`${LOCATION_NAMESPACE}/${LOCATION_GETTERS.G_LOCALES}`] || {}
  } catch (e) {
    return {}
  }
}

const getCurrentLocation = () => {
  try {
    const store = require('@/store').default
    return store?.getters?.[`${LOCATION_NAMESPACE}/${LOCATION_GETTERS.G_CURRENT_LOCATION}`]?.code || 'es'
  } catch (e) {
    return 'es'
  }
}

const vuetify = new Vuetify({
    AppScss,
    icons: {
        iconfont: 'mdi',
    },
    theme: {disable: true},
    lang: {
        locales: getLocales(),
        current: getCurrentLocation(),
    }
})

export default vuetify